import store from "../../../store"

export default [{
    path: "/app/account",
    redirect: {
        name: 'dashboard'
    },
    component: () => import("../../../views/dashboard/AccountComponent.vue"),
    children: [{
            path: "/app/account/profile",
            name: "account.profile",
            redirect: {
                name: (store.state.user.type === "customer") ? 'account.profile.personal-information' : 'account.profile.back-office'
            },
            component: () => import("../../../views/dashboard/ProfileComponent.vue"),
            children: [{
                    path: "/app/account/profile",
                    name: "account.profile.back-office",
                    component: () => import("../../../views/dashboard/back-office/ProfileComponent.vue"),
                    meta: {
                        allowedUsers: ['back-office']
                    }
                },
                {
                    path: "/app/account/profile/personal-information",
                    name: "account.profile.personal-information",
                    component: () => import("../../../views/dashboard/customer/profile/PersonalInformationComponent.vue"),
                    meta: {
                        allowedUsers: ['customer']
                    }
                },
                {
                    path: "/app/account/profile/financial-information",
                    name: "account.profile.financial-information",
                    component: () => import("../../../views/dashboard/customer/profile/FinancialInformationComponent.vue"),
                    meta: {
                        allowedUsers: ['customer']
                    }
                },
                {
                    path: "/app/account/profile/account-information",
                    name: "account.profile.account-information",
                    component: () => import("../../../views/dashboard/customer/profile/BankAccountInformationComponent.vue"),
                    meta: {
                        allowedUsers: ['customer']
                    }
                },
                // {
                //     path: "/app/account/profile/risk-profile",
                //     name: "account.profile.risk-profile",
                //     component: () => import("../../../views/dashboard/customer/profile/RiskProfileComponent.vue")
                // },
                {
                    path: "/app/account/profile/profession-information",
                    name: "account.profile.profession-information",
                    component: () => import("../../../views/dashboard/customer/profile/ProfessionInformationComponent.vue"),
                    meta: {
                        allowedUsers: ['customer']
                    }
                },
                {
                    path: "/app/account/profile/investment-management-agreement",
                    name: "account.profile.investment-management-agreement",
                    component: () => import("../../../views/dashboard/customer/profile/InvestmentManagementAgreementComponent.vue"),
                    meta: {
                        allowedUsers: ['customer']
                    }
                }
            ]
        },
        {
            path: "/app/account/settings",
            name: "account.settings",
            redirect: {
                name: 'account.settings.alerts'
            },
            component: () => import("../../../views/dashboard/SettingsComponent.vue"),
            children: [{
                    path: "/app/account/settings/alerts",
                    name: "account.settings.alerts",
                    component: () => import("../../../views/dashboard/customer/settings/AlertsComponent.vue"),
                    meta: {
                        allowedUsers: ['customer']
                    }
                },
                {
                    path: "/app/account/settings/subscriptions",
                    name: "account.settings.subsriptions",
                    component: () => import("../../../views/dashboard/customer/settings/SubscriptionComponent.vue"),
                    meta: {
                        allowedUsers: ['customer']
                    }
                },
                {
                    path: "/app/account/settings/subscriptions/:subscription",
                    name: "account.settings.subsriptions.view",
                    component: () => import("../../../views/dashboard/customer/settings/subscriptions/SubsriptionDetiailsComponent.vue"),
                    meta: {
                        allowedUsers: ['customer']
                    },
                },
                {
                    path: "/app/account/settings/change-password",
                    name: "account.settings.change-password",
                    component: () => import("../../../views/dashboard/customer/settings/ChangePasswordComponent.vue"),
                    meta: {
                        allowedUsers: ['customer']
                    }
                },
            ]
        },
    ]
}]
